export const ZellijeStar = ({ size = 34, color = "var(--brass)" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true">
    <g stroke={color} strokeWidth="1.6" fill="none">
      <path d="M50 4 L61 28 L86 18 L76 43 L98 50 L76 57 L86 82 L61 72 L50 96 L39 72 L14 82 L24 57 L2 50 L24 43 L14 18 L39 28 Z" />
      <circle cx="50" cy="50" r="16" />
      <circle cx="50" cy="50" r="8" />
    </g>
  </svg>
);

export default ZellijeStar;
